import AppMobileView from "./mobile/App.mobile.view";
import AppDesktopView from "./desktop/App.desktop.view";
import { useIsDesktopDevice } from "../../tools/hooks/useIsDesktopDevice.ts";
import { useIsMobileDevice } from "../../tools/hooks/useIsMobileDevice.ts";
import { VersionControlProvider } from "../../provider/version-control/VersionControl.provider.tsx";
import { WebSocketProvider } from "../../provider/web-socket/WebSocket.provider.tsx";
import { DragAndDropProvider } from "../../provider/drag-and-drop/DragAndDrop.provider.tsx";
import { EditMarketProvider } from "../../provider/edit-market/EditMarket.provider.tsx";
import { UserManagementProvider } from "../../provider/user-management/UserManagement.provider.tsx";

export default function AppView() {
  const isDesktop = useIsDesktopDevice();
  const isMobile = useIsMobileDevice();

  return (
    <>
      <VersionControlProvider>
        <WebSocketProvider>
          <UserManagementProvider>
            <EditMarketProvider>
              <DragAndDropProvider>
                {isMobile && <AppMobileView />}
                {isDesktop && <AppDesktopView />}
              </DragAndDropProvider>
            </EditMarketProvider>
          </UserManagementProvider>
        </WebSocketProvider>
      </VersionControlProvider>
    </>
  );
}
